// removed by extract-text-webpack-plugin
module.exports = {"TextAndImageBlock":"src-components-AlternateTextAndImageBlock----AlternateTextAndImageBlock-module---TextAndImageBlock---1L8uz","text":"src-components-AlternateTextAndImageBlock----AlternateTextAndImageBlock-module---text---2TFrz","img":"src-components-AlternateTextAndImageBlock----AlternateTextAndImageBlock-module---img---1ksWi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AlternateTextAndImageBlock/AlternateTextAndImageBlock.module.css
// module id = 370
// module chunks = 35783957827783